import { render, staticRenderFns } from "./ModuleClosedAlert.vue?vue&type=template&id=56a990f4&"
import script from "./ModuleClosedAlert.vue?vue&type=script&lang=js&"
export * from "./ModuleClosedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
